module.exports = __webpack_public_path__ + "img/Frontal_op2.50c67265.jpg";